import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { CORE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';

export const useIsBusinessProject = () => {
	const { data, loading } = useProjectContext();
	const isBusinessProject = data?.projectType === CORE_PROJECT;

	return { isBusinessProject, loading };
};
